import { useEffect } from 'react';
import { useChatbot } from '../../../contexts/ChatbotContext';
import { useDesignColors } from '../../../hooks/useDesignColors';

export function ColorPicker() {
  const { chatbotPublicId } = useChatbot();
  const { colors, setColors, initializeColors } = useDesignColors();

  const handleColorChange = (key: keyof typeof colors, value: string) => {
    if (chatbotPublicId) {
      setColors({ [key]: value }, chatbotPublicId);
    }
  };

  useEffect(() => {
    if (chatbotPublicId) {
      initializeColors(chatbotPublicId);
    }
  }, [chatbotPublicId, initializeColors]);


  return (
    <div className="space-y-4">
      <div>
        <label className="block text-sm font-medium text-gray-300 mb-2">
          Gradient start color
        </label>
        <div className="flex items-center gap-3">
          <div className="relative">
            <input
              type="color"
              value={colors.gradientStart}
              onChange={(e) => handleColorChange('gradientStart', e.target.value)}
              className="absolute inset-0 opacity-0 w-full h-full cursor-pointer"
            />
            <div 
              className="w-10 h-10 rounded border border-white/10"
              style={{ backgroundColor: colors.gradientStart }}
            />
          </div>
          <input
            type="text"
            value={colors.gradientStart}
            onChange={(e) => handleColorChange('gradientStart', e.target.value)}
            className="flex-1 bg-white/5 border border-white/10 rounded-lg px-3 py-2 text-white focus:outline-none focus:ring-2 focus:ring-indigo-500"
          />
        </div>
      </div>

      <div>
        <label className="block text-sm font-medium text-gray-300 mb-2">
          Gradient end color
        </label>
        <div className="flex items-center gap-3">
          <div className="relative">
            <input
              type="color"
              value={colors.gradientEnd}
              onChange={(e) => handleColorChange('gradientEnd', e.target.value)}
              className="absolute inset-0 opacity-0 w-full h-full cursor-pointer"
            />
            <div 
              className="w-10 h-10 rounded border border-white/10"
              style={{ backgroundColor: colors.gradientEnd }}
            />
          </div>
          <input
            type="text"
            value={colors.gradientEnd}
            onChange={(e) => handleColorChange('gradientEnd', e.target.value)}
            className="flex-1 bg-white/5 border border-white/10 rounded-lg px-3 py-2 text-white focus:outline-none focus:ring-2 focus:ring-indigo-500"
          />
        </div>
      </div>
    </div>
  );
}